"use client"

type WindowWithDataLayer = Window & {
  dataLayer: Record<string, any>[]
}

declare const window: WindowWithDataLayer

// Info menu click functions
export const infoMenuClick = (text: string, category: string) => {
  if (typeof window.dataLayer !== "undefined") {
    window.dataLayer.push({
      event: "info_menu_click",
      click_text: text, // The text displayed on the button that was clicked
      category1: category, // Category1 name
      element_name: "תפריט ריבועים ראשי", // The name of the element that was interacted with
    })
  }
}

export const infoClick = (
  text: string,
  subText: string,
  category: string,
  elementName: string,
) => {
  if (typeof window.dataLayer !== "undefined") {
    window.dataLayer.push({
      event: "info_click",
      click_text: text, // The text displayed on the button that was clicked
      sub_click_text: subText, // Sub-category or description associated with the clicked text
      category1: category, // Category1 name
      element_name: elementName, // The name of the element that was interacted with
    })
  }
}

export const subInfoClick = (
  text: string,
  category: string,
  elementName: string,
) => {
  if (typeof window.dataLayer !== "undefined") {
    window.dataLayer.push({
      event: "sub_info_click",
      click_text: text, // The text displayed on the button that was clicked
      category1: category, // Category1 name
      element_name: elementName, // The name of the element that was interacted with
    })
  }
}

// Bus payment report functions
export const busPaymentReportStep = (
  text: string,
  stepNumber: string,
  stepName: string,
) => {
  if (typeof window.dataLayer !== "undefined") {
    window.dataLayer.push({
      event: "bus_payment_report_step",
      click_text: text, // The text displayed on the button that was clicked
      step_number: stepNumber, // Step number
      step_name: stepName, // Step name
      category1: "מידע לנוסעים", // Category1 name
      element_name: "תשלום תעריף מוגדל", // Element name
    })
  }
}

export const busPaymentReportError = (
  text: string,
  stepNumber: string,
  stepName: string,
  errorName: string,
) => {
  if (typeof window.dataLayer !== "undefined") {
    window.dataLayer.push({
      event: "bus_payment_report_error",
      click_text: text, // The text displayed on the button that was clicked
      step_number: stepNumber, // Step number
      step_name: stepName, // Step name
      category1: "מידע לנוסעים", // Category1 name,
      errorName: errorName, // Error name
      element_name: "תשלום תעריף מוגדל", // Element name
    })
  }
}

export const busPaymentReportSuccess = () => {
  if (typeof window.dataLayer !== "undefined") {
    window.dataLayer.push({
      event: "bus_payment_report_success",
      step_name: 3, // Step name
      category1: "מידע לנוסעים", // Category1 name
      element_name: "תשלום תעריף מוגדל", // Element name
    })
  }
}

// FAQ functions
export const pageStripFaq = (
  text: string,
  subText: string,
  category: string,
  elementName: string,
) => {
  if (typeof window.dataLayer !== "undefined") {
    window.dataLayer.push({
      event: "page_strip_faq",
      click_text: text, // The text displayed on the button that was clicked
      sub_click_text: subText, // Sub-category or description associated with the clicked text
      category1: category, // Category1 name
      element_name: elementName, // The name of the element that was interacted with
    })
  }
}

// Rav Kav functions
export const ravKavLocateStations = (text: string) => {
  if (typeof window.dataLayer !== "undefined") {
    window.dataLayer.push({
      event: "rav_kav_locate_stations",
      click_text: text, // The text displayed on the button that was clicked
      category1: "מידע לנוסעים", // Category1 name
      element_name: "אפליקציות תשלום", // The name of the element that was interacted with
    })
  }
}

export const ravKavTypes = (text: string, subText: string) => {
  if (typeof window.dataLayer !== "undefined") {
    window.dataLayer.push({
      event: "rav_kav_types",
      click_text: text, // The text displayed on the button that was clicked
      sub_click_text: subText, // Sub-category or description associated with the clicked text
      category1: "מידע לנוסעים", // Category1 name
      element_name: "אפליקציות תשלום", // The name of the element that was interacted with
    })
  }
}

export const methodsPaymentPublicTransport = (text: string) => {
  if (typeof window.dataLayer !== "undefined") {
    window.dataLayer.push({
      event: "methods_payment_public_transport",
      click_text: text, // The text displayed on the button that was clicked
      category1: "מידע לנוסעים", // Category1 name
      element_name: "אפליקציות תשלום", // The name of the element that was interacted with
    })
  }
}

// Contact functions
export const menuContactClick = (text: string, subText: string) => {
  if (typeof window.dataLayer !== "undefined") {
    window.dataLayer.push({
      event: "menu_contact_click",
      click_text: text, // The text displayed on the button that was clicked
      sub_click_text: subText, // Sub-category or description associated with the clicked text
      category1: "מידע לנוסעים", // Category1 name
      element_name: "יצירת קשר", // The name of the element that was interacted with
    })
  }
}

export const applicationContactClick = (text: string, subText: string) => {
  if (typeof window.dataLayer !== "undefined") {
    window.dataLayer.push({
      event: "application_contact_click",
      click_text: text, // The text displayed on the button that was clicked
      sub_click_text: subText, // Sub-category or description associated with the clicked text
      category1: "מידע לנוסעים", // Category1 name
      element_name: "יצירת קשר", // The name of the element that was interacted with
    })
  }
}

export const applicationRequestClick = (text: string, subText: string) => {
  if (typeof window.dataLayer !== "undefined") {
    window.dataLayer.push({
      event: "application_request_click",
      click_text: text, // The text displayed on the button that was clicked
      sub_click_text: subText, // Sub-category or description associated with the clicked text
      category1: "מידע לנוסעים", // Category1 name
      element_name: "יצירת קשר", // The name of the element that was interacted with
    })
  }
}

export const applicationRequestSuccess = (text: string, subText: string) => {
  if (typeof window.dataLayer !== "undefined") {
    window.dataLayer.push({
      event: "application_request_success",
      click_text: text, // The text displayed on the button that was clicked
      sub_click_text: subText, // Sub-category or description associated with the clicked text
      category1: "מידע לנוסעים", // Category1 name
      element_name: "יצירת קשר", // The name of the element that was interacted with
    })
  }
}

export const applicationRequestError = (text: string, subText: string) => {
  if (typeof window.dataLayer !== "undefined") {
    window.dataLayer.push({
      event: "application_request_error",
      click_text: text, // The text displayed on the button that was clicked
      sub_click_text: subText, // Sub-category or description associated with the clicked text
      category1: "מידע לנוסעים", // Category1 name
      element_name: "יצירת קשר", // The name of the element that was interacted with
    })
  }
}

// Career functions
export const jobInfoClick = (text: string, subText: string) => {
  if (typeof window.dataLayer !== "undefined") {
    window.dataLayer.push({
      event: "job_info_click",
      click_text: text, // The text displayed on the button that was clicked
      sub_click_text: subText, // Sub-category or description associated with the clicked text
      category1: "תחבורה ציבורית", // Category1 name
      element_name: "קריירה - מטה", // The name of the element that was interacted with
    })
  }
}

export const sendCvClick = (text: string, subText: string) => {
  if (typeof window.dataLayer !== "undefined") {
    window.dataLayer.push({
      event: "send_cv_click",
      click_text: text, // The text displayed on the button that was clicked
      sub_click_text: subText, // Sub-category or description associated with the clicked text
      category1: "תחבורה ציבורית", // Category1 name
      element_name: "קריירה - מטה", // The name of the element that was interacted with
    })
  }
}

export const sendCvSuccess = (text: string, subText: string) => {
  if (typeof window.dataLayer !== "undefined") {
    window.dataLayer.push({
      event: "send_cv_success",
      click_text: text, // The text displayed on the button that was clicked
      sub_click_text: subText, // Sub-category or description associated with the clicked text
      category1: "תחבורה ציבורית", // Category1 name
      element_name: "קריירה - מטה", // The name of the element that was interacted with
    })
  }
}

export const sendCvError = (text: string, subText: string) => {
  if (typeof window.dataLayer !== "undefined") {
    window.dataLayer.push({
      event: "send_cv_error",
      click_text: text, // The text displayed on the button that was clicked
      sub_click_text: subText, // Sub-category or description associated with the clicked text
      category1: "תחבורה ציבורית", // Category1 name
      element_name: "קריירה - מטה", // The name of the element that was interacted with
    })
  }
}
